export default __webpack_public_path__ + "media/images/limited-offer-text-61df8ea0.png";